import { render, staticRenderFns } from "./DistancesList.vue?vue&type=template&id=27775a62"
import script from "./DistancesList.vue?vue&type=script&lang=ts"
export * from "./DistancesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports